import type { SetState } from "zustand";
import type { SnagGroupingMode } from "~/screens/App/screens/Project/Visits/screens/VisitExecuteScreen/execute.grouping";
import type { ExecuteSnagMode } from "~/screens/App/screens/Project/Visits/screens/VisitExecuteScreen/execute.types";

type UserSnagsPreferencesState = {
  snagViewMode: ExecuteSnagMode;
  snagGroupingMode: SnagGroupingMode;
  setSnagViewMode: (snagViewMode: ExecuteSnagMode) => void;
  setSnagGroupingMode: (snagGroupingMode: SnagGroupingMode) => void;
};

const userSnagsPreferencesStore = (
  set: SetState<UserSnagsPreferencesState>
): UserSnagsPreferencesState => ({
  setSnagGroupingMode: (snagGroupingMode) => set({ snagGroupingMode }),
  setSnagViewMode: (snagViewMode) => set({ snagViewMode }),
  snagGroupingMode: "all",
  snagViewMode: "all",
});

export type { UserSnagsPreferencesState };
export { userSnagsPreferencesStore };
